import { useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';
const useChartTheme = () => {
    const theme = useTheme();
    const COLORS = useMemo(() => {
        return [
            theme.colors.purple_1,
            theme.colors.purple_3,
            theme.colors.green_1,
            theme.colors.yellow_1,
            theme.colors.error,
            theme.colors.grey_1,
            theme.colors.green_3,
            theme.colors.blue_1,
            theme.colors.orange_1,
            theme.colors.orange_2,
        ];
    }, [theme]);
    const COLORS_EXCEPT_PURPLE1 = useMemo(() => {
        return [
            theme.colors.purple_3,
            theme.colors.green_1,
            theme.colors.yellow_1,
            theme.colors.error,
            theme.colors.grey_1,
            theme.colors.green_3,
            theme.colors.blue_1,
            theme.colors.orange_1,
            theme.colors.orange_2,
        ];
    }, [theme]);
    const getColor = useCallback((index, highlightedIndex, isHighlighted, multiHighlightedCount) => {
        const multipleActive = typeof multiHighlightedCount === 'number' && multiHighlightedCount > 1;
        if (isHighlighted && !multipleActive) {
            return theme.colors.purple_1;
        }
        if (typeof highlightedIndex === 'number' && !isHighlighted && !multipleActive) {
            return COLORS_EXCEPT_PURPLE1[index % COLORS_EXCEPT_PURPLE1.length];
        }
        return COLORS[index % COLORS.length];
    }, [COLORS, COLORS_EXCEPT_PURPLE1, theme.colors.purple_1]);
    return { COLORS, getColor };
};
export default useChartTheme;
